var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 1.1665C3.78002 1.1665 1.16669 3.77984 1.16669 6.99984C1.16669 10.2198 3.78002 12.8332 7.00002 12.8332C10.22 12.8332 12.8334 10.2198 12.8334 6.99984C12.8334 3.77984 10.22 1.1665 7.00002 1.1665ZM7.00002 11.6665C4.42752 11.6665 2.33335 9.57234 2.33335 6.99984C2.33335 4.42734 4.42752 2.33317 7.00002 2.33317C9.57252 2.33317 11.6667 4.42734 11.6667 6.99984C11.6667 9.57234 9.57252 11.6665 7.00002 11.6665ZM9.67752 4.4215L5.83335 8.26567L4.32252 6.76067L3.50002 7.58317L5.83335 9.9165L10.5 5.24984L9.67752 4.4215Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.271a1fae.svg";
export { ForwardRef as ReactComponent };